<ng-container *ngIf="(getState$ | async).isAuthenticated as isAuthenticated; else notAuthenticated">
  <!-- SIDE PANEL -->
  <ng-container *ngIf="!fuseConfig.layout.sidepanel.hidden && fuseConfig.layout.sidepanel.position === 'left'">
    <!-- PANEL CONTENT -->
  </ng-container>
  <!-- / SIDE PANEL -->

  <div id="main">

    <!-- TOOLBAR: Above -->
    <ng-container
      *ngIf="fuseConfig.layout.toolbar.position === 'above' && displayNavBar && !fuseConfig?.layout?.toolbar?.hidden">
      <ng-container *ngTemplateOutlet="toolbar"></ng-container>
    </ng-container>
    <!-- / TOOLBAR: Above -->

    <div id="container-1" class="container">

      <!-- NAVBAR: Left -->
      <ng-container *ngIf="fuseConfig.layout.navbar.position === 'left'">
        <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
      </ng-container>
      <!-- / NAVBAR: Left -->

      <div id="container-2" class="container">

        <!-- Layout utilisé par l'app :) -->

        <!-- TOOLBAR: Below fixed -->
        <ng-container
          *ngIf="fuseConfig.layout.toolbar.position === 'below-fixed' && displayNavBar && !fuseConfig?.layout?.toolbar?.hidden">
          <ng-container *ngTemplateOutlet="toolbar"></ng-container>
        </ng-container>
        <!-- / TOOLBAR: Below fixed -->

        <!--      <div id="container-3" class="container" style="border-style: double;border-width: 2px;border-color:red;">-->

        <!--        <div id="container-3"-->
        <!--             class="container"-->
        <!--             fusePerfectScrollbar-->
        <!--             [fusePerfectScrollbarOptions]="{suppressScrollX: true, updateOnRouteChange : true}"-->
        <!--        >-->
        <div id="container-3" class="container">

          <!-- TOOLBAR: Below static -->
          <ng-container
            *ngIf="fuseConfig.layout.toolbar.position === 'below-static' && displayNavBar && !fuseConfig?.layout?.toolbar?.hidden">
            <ng-container *ngTemplateOutlet="toolbar"></ng-container>
          </ng-container>
          <!-- / TOOLBAR: Below static -->

          <!-- CONTENT -->
          <!--        <content *appLoadingUntil="isLoggedToFirebase;subSpinnerTemplate:spinnerMessageTemplate"></content>-->
          <content style="height: 100%; overflow-y: hidden;"></content>
          <!-- / CONTENT -->

          <!-- FOOTER: Below static -->
          <ng-container *ngIf="fuseConfig.layout.footer.position === 'below-static'">
            <ng-container *ngTemplateOutlet="footer"></ng-container>
          </ng-container>
          <!-- / FOOTER: Below static -->

        </div>

        <!-- FOOTER: Below fixed -->
        <ng-container *ngIf="fuseConfig.layout.footer.position === 'below-fixed'">
          <ng-container *ngTemplateOutlet="footer"></ng-container>
        </ng-container>
        <!-- / FOOTER: Below fixed -->

      </div>

      <!-- NAVBAR: Right -->
      <ng-container *ngIf="fuseConfig.layout.navbar.position === 'right'">
        <ng-container *ngTemplateOutlet="rightNavbar"></ng-container>
      </ng-container>
      <!-- / NAVBAR: Right -->

    </div>

    <!-- FOOTER: Above -->
    <ng-container *ngIf="fuseConfig.layout.footer.position === 'above'">
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    </ng-container>
    <!-- FOOTER: Above -->

  </div>

  <!-- SIDE PANEL -->
  <ng-container *ngIf="!fuseConfig.layout.sidepanel.hidden && fuseConfig.layout.sidepanel.position === 'right'">

    <!-- PANEL CONTENT -->

  </ng-container>
  <!-- / SIDE PANEL -->

  <!-- QUICK PANEL -->
  <fuse-sidebar name="quickPanel" position="right" class="quick-panel">
    <quick-panel></quick-panel>
  </fuse-sidebar>
  <!-- / QUICK PANEL -->

  <!-- ----------------------------------------------------------------------------------------------------- -->
  <!-- @ PARTIALS                                                                                            -->
  <!-- ----------------------------------------------------------------------------------------------------- -->

  <!-- TOOLBAR -->
  <ng-template #toolbar>
    <toolbar *ngIf="!fuseConfig?.layout?.toolbar?.hidden && displayNavBar"
      [ngClass]="fuseConfig.layout.toolbar.customBackgroundColor === true ? fuseConfig.layout.toolbar.position + ' ' + fuseConfig.layout.toolbar.background : fuseConfig.layout.toolbar.position">
    </toolbar>
  </ng-template>
  <!-- / TOOLBAR -->

  <!-- FOOTER -->
  <ng-template #footer>
    <footer *ngIf="!fuseConfig.layout.footer.hidden"
      [ngClass]="fuseConfig.layout.footer.customBackgroundColor === true ? fuseConfig.layout.footer.position + ' ' + fuseConfig.layout.footer.background : fuseConfig.layout.footer.position">
    </footer>
  </ng-template>
  <!-- / FOOTER -->

  <!-- LEFT NAVBAR -->
  <ng-template #leftNavbar>
    <fuse-sidebar name="navbar" class="navbar-fuse-sidebar" [folded]="fuseConfig.layout.navbar.folded"
      [foldedAutoTriggerOnHover]="true" lockedOpen="gt-md" *ngIf="!fuseConfig.layout.navbar.hidden">
      <navbar [variant]="fuseConfig.layout.navbar.variant" class="left-navbar"></navbar>
    </fuse-sidebar>
    <div *ngIf="displayNavBar && !fuseConfig.layout.navbar.hidden" style="width: 64px !important; height: 100%"></div>
  </ng-template>
  <!-- / LEFT NAVBAR -->

  <!-- RIGHT NAVBAR -->
  <ng-template #rightNavbar>
    <fuse-sidebar name="navbar" position="right" class="navbar-fuse-sidebar" [folded]="fuseConfig.layout.navbar.folded"
      [foldedAutoTriggerOnHover]="true" lockedOpen="gt-md" *ngIf="!fuseConfig.layout.navbar.hidden">
      <navbar [variant]="fuseConfig.layout.navbar.variant" class="right-navbar"></navbar>
    </fuse-sidebar>
  </ng-template>
  <!-- / RIGHT NAVBAR -->

  <ng-template #spinnerMessageTemplate>
    <h2><i class="mdi mdi-firebase"></i> {{'Veuillez patienter'|translate}}...</h2>
  </ng-template>
</ng-container>

<ng-template #notAuthenticated>

  <ng-container *ngIf="(getState$ | async).inLoggingScreen; else delogging">
    <content></content>
  </ng-container>

  <ng-template #delogging>
    <div id="main">
      <div class="waiting-panel">
        <div class="center">
          <div class="logo w-100-p" appFlexLayout="column">
            <div appFlex="noshrink" appFlexLayout="column" appFlexAlign="center center">
              <div>
                <img width="77" src="assets/images/logos/logo_no_text_white.svg">
              </div>
            </div>
            <div appFlex="noshrink" appFlexLayout="column" appFlexAlign="center center">
              <div class="mt-24">
                <mat-spinner [diameter]="48"></mat-spinner>
              </div>
              <div class="wait-label">
                <h2>{{'Au revoir'|translate}}...</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

</ng-template>